export default {
  'component.shared.countrySelect.placeholder': 'Please select a country.',
  'component.shared.centralExamTypeSelect.placeholder': 'Select Central Exam Type.',
  'component.shared.institutionSelect.placeholder': 'Select Institution.',
  'component.shared.departmentsOfUnitSelect.placeholder': 'Select Department.',
  'component.shared.unitSelect.placeholder': 'Select Unit.',
  'component.shared.majorScienceBranchOfDepartmentSelect.placeholder':
    'Select Major Science Branch.',
  'component.ui.infiniteSearchSelect.loading': 'Loading...',
  'component.shared.studentLevelSelect.placeholder': 'Please select a level.',
  'component.shared.documentTypeSelect.placeholder': 'Please select a document type.',
  'component.image.preview': 'Preview',
  'component.shared.academicSeasonSelect.placeholder': 'Please select an academic season.',
  'component.shared.applicationStatusSelect.options.applicationNotSubmitted':
    'Application NOT submitted (1)',
  'component.shared.applicationStatusSelect.options.pendingApproval':
    'Application received, preview phase  (2)',
  'component.shared.applicationStatusSelect.options.applicationAccepted':
    'Sent to the Admission Committee (3)',
  'component.shared.applicationStatusSelect.options.applicationNotAccepted':
    'Application is INCOMPLETE  (4)',
  'component.shared.applicationStatusSelect.options.studentAccepted':
    'Approved(international s. sent to Finance Dept)(5)',
  'component.shared.applicationStatusSelect.options.noStudentAccepted':
    'Application NOT approved (6)',
  'component.shared.applicationStatusSelect.options.earlyPaymentReceived':
    'Early Payment Received (7)',
  'component.reCaptcha.error': 'Please complete the reCAPTCHA verification.',
};
